var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95964 7.79199L7.79297 1.41699C8.35655 1.41699 8.89706 1.64088 9.29557 2.03939C9.69409 2.43791 9.91797 2.97841 9.91797 3.54199V6.37533H13.9271C14.1325 6.373 14.3359 6.41535 14.5232 6.49944C14.7106 6.58353 14.8774 6.70735 15.0122 6.86232C15.147 7.01728 15.2464 7.1997 15.3037 7.39692C15.3609 7.59414 15.3746 7.80145 15.3438 8.00449L14.3663 14.3795C14.3151 14.7173 14.1435 15.0252 13.8832 15.2465C13.6228 15.4678 13.2913 15.5875 12.9496 15.5837H4.95964M4.95964 7.79199V15.5837M4.95964 7.79199H2.83464C2.45891 7.79199 2.09858 7.94125 1.8329 8.20692C1.56722 8.4726 1.41797 8.83294 1.41797 9.20866V14.167C1.41797 14.5427 1.56722 14.9031 1.8329 15.1687C2.09858 15.4344 2.45891 15.5837 2.83464 15.5837H4.95964",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.05fc2547cace231c1964b1bdd9f30050.svg";
export { ForwardRef as ReactComponent };